import css from "styled-jsx/css";
import { rdcUiTheme } from "@rdc-npm/rdc-ui";
export default css`
  @import "src/static/styles/variables";
  @import "src/static/styles/mixins/mixins";
  @import "src/static/styles/global";
  .profile-incomplete-head {
    margin-top: 40px;
  }
  .showless {
    color: ${rdcUiTheme.color.text.primary};
    text-decoration-line: underline;
    font-size: 12px;
    letter-spacing: 0.5px;
    line-height: 16px;
    font-weight: ${rdcUiTheme.typography.weight.medium};
    p {
      margin-top: 16px;
      cursor: pointer;
    }
  }
  .preview-more-details {
    padding-bottom: 24px;
  }
  .accordian-divider {
    padding-bottom: 24px;
  }
  .about-profile {
    margin-top: 42px;
  }
  .fallBackImg {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    object-fit: cover;
  }
  .profile-description {
    padding: 1.5em 0;
    position: relative;
  }
  .profile-more-info {
    font-weight: ${rdcUiTheme.typography.weight.bold};
    padding-bottom: 10px;
  }
  .preview-about-sub {
    color: ${rdcUiTheme.color.text.primary};
    font-weight: ${rdcUiTheme.typography.weight.normal};
    font-size: 16px;
    line-height: 24px;
    position: relative;
  }
  .preview-about-sub .showDescription {
    display: block;
    background: ${rdcUiTheme.color.bg.primary};
  }

  // Mobile Responsive
  @include mobile {
    .preview-about-sub .empty-about {
      display: block;
      background: ${rdcUiTheme.color.bg.primary};
    }
    .languages-content {
      margin-bottom: 0px;
    }
    .accordian-divider {
      margin: 0px 0px;
    }
    .preview-about {
      height: auto;
    }
    .preview-main-content {
      border-bottom: none !important;
    }
    .preview-main-content {
      padding: 24px 16px 0;
    }
    .preview-about-main {
      width: 100%;
      font-size: 18px;
    }
    #profile-section .profile-details .profile-img {
      max-width: 100%;
      height: 60px;
      width: 60px;
    }
    #profile-section .profile-details .profile-img img {
      height: 60px;
      width: 60px;
      border-radius: 50%;
    }
    .profile-Tiltle-con {
      position: absolute;
      right: 5%;
      list-style-type: none;
      display: block;
    }
    .empty-content-text {
      @include truncate(100%);
      margin-top: 3px;
      width: 100%;
    }
    .mobile-profile-info {
      width: 67%;
    }
    // .preview-profile-info-right {
    //   margin-right: 5%;
    //   width: 27%;
    //   float: left;
    // }
    // .preview-profile-info-left {
    //   width: 62%;
    //   float: left;
    //   margin-left: 29%;
    // }

    .preview-profile-sub-title {
      @include truncate(240px);
      white-space: normal;
      width: 150px;
    }
    .preview-profile-sub-subtitle {
      width: 150px;
    }
    .profile-Tiltle {
      width: 78%;
    }
    .stickyspace {
      flex-direction: column;
    }
  }

  .profile-Tiltle-Team-top {
    border-radius: 16px;
    background-color: ${rdcUiTheme.color.gray[300]};
    padding: 2px 8px 2px 8px;
    height: 23px;
    width: 50px;
    color: ${rdcUiTheme.color.text.primary};
    font-size: 12px;
    font-weight: ${rdcUiTheme.typography.weight.bold};
    line-height: 11px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    position: absolute;
    top: -32px;
  }

  @include tab {
    .accordian-divider {
      margin: 4px 0px;
    }
    .languages-content {
      margin-bottom: 0px;
    }
    .preview-main-content {
      width: 760px !important;
      padding: 0 40px;
      border-bottom: none !important;
    }
    // .preview-main-content {
    //   width: 80%;
    //   max-width: 100%;
    //   float: left;
    //   position: relative;
    //   left: 9%;
    // }
  }
  @include normalTab {
    .preview-main-content {
      // width: 100% !important;
      max-width: 100%;
      // float: left;
      position: relative;
    }
  }
  @include normalDesk {
    .preview-main-content {
      width: 610px !important;
    }
  }
  @include bigDesktop {
    .preview-main-content {
      width: 610px !important;
    }
  }
  @include extraNormalDesk {
    .preview-main-content {
      width: 610px !important;
    }
  }
  @media only screen and (max-width: 1280px) and (min-width: 1024px) {
    .preview-main-content {
      margin-bottom: 24px !important;
      padding: 0 40px 0 5px !important;
    }
  }

  // Above Laptop
  @media (min-width: 1281px) {
    .preview-main-content {
      width: 770px !important;
    }
  }
`;
